import { TmBaseError } from '@/core/error/tmBaseError'

export class TmWrapperError extends TmBaseError {
  public name = 'TmWrapperError'
}
